import { PlatIngredient } from "./PlatIngredient";
import { PlatVariacio } from "./PlatVariacio";

class Plat {
    constructor(
        public id: number = 0,
        public nom: string = "",
        public tipus: string = "",
        public grup: string = "",
        public cuinat: string = "",
        public cost: number = 0.0,
        public estat: number = 0,
        public finalitzat: string = "",
        public ingredients: Array<PlatIngredient> = [],
        public variacions: Array<PlatVariacio> = [],
    ) {
    }
}
export {Plat};